// @ts-strict-ignore
import React from 'react'
import { graphql, useFragment } from 'react-relay'
import {
  Page,
  PageBody,
  PageContent,
  PageHeader,
  PageHeaderBreadcrumbs,
  PageHeaderTitle,
  PageSidebar,
} from 'components/Layouts/V3'
import { useRouter } from 'next/router'
import { DiscussionEmbed } from 'disqus-react'
import { getCurrentLocationFull } from 'services/router'
import { BlogPostSignedIn_BlogPost$key } from '__generated__/BlogPostSignedIn_BlogPost.graphql'
import Suspense from 'components/Suspense'
import { Card } from '@mui/material'
import useStyles from './styles'
import ProfileHireBox from './components/ProfileHireBox'
import BlogPostContent from '../BlogPostContent/BlogPostContent'

export interface IBlogPostSignedInProps {
  blogPostFragmentRef: BlogPostSignedIn_BlogPost$key
}

function BlogPostSignedIn(props: IBlogPostSignedInProps) {
  const { blogPostFragmentRef } = props
  const router = useRouter()
  const { classes } = useStyles()

  const blogPost = useFragment(
    graphql`
      fragment BlogPostSignedIn_BlogPost on BlogPost {
        id
        slug
        title
        user {
          profile {
            slug
          }
          id
        }
        ...BlogPostContent_BlogPost
        ...MetaInfo_BlogPostFragment
        ...ProfileHireBox_BlogPostFragment
      }
    `,
    blogPostFragmentRef,
  )

  if (!blogPost) {
    return null
  }

  return (
    <Page>
      <PageHeader>
        <PageHeaderTitle>
          Flexhire Blog
        </PageHeaderTitle>

        <PageHeaderBreadcrumbs
          breadcrumbs={[
            {
              name: 'Blog',
              href: '/blog',
            },
            {
              name: 'Post',
              href: '/blog',
            },
            {
              name: blogPost.title,
              href: `/blog/${blogPost.user.profile.slug}/${blogPost.title}`,
            },
          ]}
        />
      </PageHeader>

      <PageBody>
        <PageContent maxWidth="lg">
          <Card>
            <Suspense>
              <BlogPostContent blogPostFragmentRef={blogPost} />
            </Suspense>
          </Card>

          <div className={classes.commentsWrapper}>
            <DiscussionEmbed
              config={{ url: getCurrentLocationFull(router), identifier: blogPost?.id.toString(), title: blogPost?.title }}
              shortname={process.env.NEXT_PUBLIC_DISQUS_SHORTNAME || ''}
            />
          </div>
        </PageContent>

        <PageSidebar sticky style={{ background: 'none', border: 'none' }}>
          <ProfileHireBox blogPostFragment={blogPost} />
        </PageSidebar>
      </PageBody>
    </Page>
  )
}

export default React.memo(BlogPostSignedIn)
